import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow, Button } from "../components/primitives";
import { Seo } from "../components/Seo";
import { IMAGES } from "../lib/api";

export default function About() {
  return (
    <>
      <Seo title="Our Story" description="The founder story behind Glam Wagon — why a values-driven beauty company exists, and how the chair becomes a place of genuine human care." image={IMAGES.founder} />
      <section className="pt-40 pb-20 max-w-7xl mx-auto px-6 lg:px-12" data-testid="about-hero">
        <Reveal>
          <Eyebrow>Our story</Eyebrow>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-[5rem] leading-[0.98] tracking-tight mt-6 max-w-4xl text-ink">
            Why Glam Wagon exists.
          </h1>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-24 grid md:grid-cols-12 gap-16 items-start">
        <div className="md:col-span-7 order-2 md:order-1 space-y-8 text-lg leading-relaxed text-ink-soft">
          <Reveal>
            <p className="font-serif text-3xl leading-snug text-ink italic">
              "I kept noticing something in the chair. People didn't just want to look different — they
              wanted to feel seen."
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p>
              Glam Wagon was born from a simple, stubborn belief: that a business can be genuinely
              profitable while operating with integrity, transparency, and compassion. Not as a slogan
              — as a discipline.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p>
              We start as a mobile beauty business offering professional salon services, meeting
              people where they are. But the conversations that happen while someone is in the chair
              are where the real work lives. A haircut becomes a chance to encourage. A color
              appointment becomes an hour where someone feels genuinely cared for.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p>
              Beauty services are simply the beginning. The long-term vision is to build an
              organization that proves — clearly, measurably — that ethical businesses can outperform
              companies built solely around profit. We intend to be the evidence.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="flex flex-wrap gap-4 pt-4">
              <Button as={Link} to="/constitution" data-testid="about-constitution-btn">
                Read the Constitution
              </Button>
              <Button as={Link} to="/support" variant="outline" data-testid="about-support-btn">
                Support the vision <ArrowRight size={16} />
              </Button>
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-5 order-1 md:order-2">
          <Reveal>
            <img src={IMAGES.founder} alt="Founder" className="rounded-3xl w-full h-[560px] object-cover shadow-xl shadow-black/5" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
